<template>
    <nav class="nav-main" :class="{ owner: $onduro.hasRole('owner') }">
        <a
            class="toggle-menu"
            href="#"
            @click.stop.prevent="toggleNavigation()"
            @touchstart="touching = true"
        >
            <icon name="menu" viewBox="0 0 24 24" />
        </a>

        <router-link class="link-home" :to="$onduro.route('overview')">
            <icon name="logo" viewBox="0 0 842 170" />
        </router-link>

        <ul v-if="appReady">
            <li>
                <router-link
                    class="router-link"
                    :to="$onduro.route('overview')"
                >
                    <icon
                        name="inbox"
                        v-tooltip="showTooltip('route.overview.name')"
                    />{{ $t("route.overview.name") }}
                </router-link>
            </li>

            <li>
                <router-link
                    class="router-link"
                    :to="$onduro.route('company')"
                    v-if="
                        $onduro.hasModule('company') &&
                        ($onduro.getConfig('company.visible') ||
                            $onduro.hasRole('manager'))
                    "
                >
                    <icon
                        name="company"
                        v-tooltip="showTooltip('route.company.name')"
                    />{{ $t("route.company.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.hasModule('checkins') &&
                    $onduro.hasRole('supervisor')
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('checkins')"
                >
                    <icon
                        name="checkin"
                        v-tooltip="showTooltip('route.checkins.name')"
                    />{{ $t("route.checkins.name") }}<i class="beta">BETA</i>
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasModule('today') &&
                    $onduro.hasRole(['planner', 'observer'])
                "
            >
                <router-link class="router-link" :to="$onduro.route('today')">
                    <icon
                        name="spot"
                        v-tooltip="showTooltip('route.today.name')"
                    />{{ $t("route.today.name") }}
                </router-link>
            </li>

            <li>
                <router-link
                    class="router-link"
                    :to="$onduro.route('clients')"
                    v-if="
                        $onduro.isReal() &&
                        $onduro.hasModule('clients') &&
                        $onduro.hasRole('planner', 'manager', 'owner')
                    "
                >
                    <icon
                        name="apartment"
                        v-tooltip="showTooltip('route.clients.name')"
                    />{{ $t("route.clients.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasModule('planning') &&
                    $onduro.hasRole('planner', 'observer') &&
                    $store.state.current.membership.locations.length
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('planning')"
                >
                    <icon
                        :name="$onduro.hasRole('planner') ? 'calendar' : 'eye'"
                        v-tooltip="showTooltip('route.planning.name')"
                    />{{ $t("route.planning.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasModule('planning') &&
                    $store.state.current.membership.locations.length
                "
            >
                <router-link class="router-link" :to="$onduro.route('roster')">
                    <icon
                        name="assignment"
                        v-tooltip="showTooltip('route.roster.name')"
                    />{{ $t("route.roster.name") }}
                </router-link>
            </li>

            <li v-if="$onduro.hasModule('lists') && $onduro.hasRole('planner')">
                <router-link class="router-link" :to="$onduro.route('lists')">
                    <icon
                        name="list"
                        v-tooltip="showTooltip('route.lists.name')"
                    />{{ $t("route.lists.name") }}
                </router-link>
            </li>

            <li v-if="$onduro.isReal() && showAvailability">
                <router-link
                    class="router-link"
                    :to="$onduro.route('availability')"
                >
                    <icon
                        name="checkmark"
                        v-tooltip="showTooltip('route.availability.name')"
                    />{{ $t("route.availability.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasModule('contacts') &&
                    ($onduro.hasRight('contacts.view') ||
                        $onduro.getConfig('contacts.visibility'))
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('contacts')"
                >
                    <icon
                        name="phone"
                        v-tooltip="showTooltip('route.contacts.name')"
                    />{{ $t("route.contacts.name") }}
                </router-link>
            </li>

            <li v-if="$onduro.hasModule('chats')">
                <router-link class="router-link" :to="$onduro.route('chats')">
                    <icon
                        name="chat"
                        v-tooltip="showTooltip('route.chats.name')"
                    />{{ $t("route.chats.name") }}
                    <chat-bubble getter="chat/countUnread" limit="99" />
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasModule('hours') &&
                    $onduro.hasRole('biller', 'supervisor')
                "
            >
                <router-link class="router-link" :to="$onduro.route('hours')">
                    <icon
                        name="clock"
                        v-tooltip="showTooltip('route.hours.name')"
                    />{{ $t("route.hours.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.hasModule('balances') &&
                    (balance || $onduro.hasRight('balances.overview'))
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('balances')"
                >
                    <icon
                        name="balance"
                        v-tooltip="showTooltip('route.balances.name')"
                    />{{ $t("route.balances.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.hasModule('hours') && $onduro.hasRole('accountant')
                "
            >
                <router-link class="router-link" :to="$onduro.route('reports')">
                    <icon
                        name="calculator"
                        v-tooltip="showTooltip('route.reports.name')"
                    />{{ $t("route.reports.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasModule('statistics') &&
                    $onduro.hasRole(['accountant', 'owner'])
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('statistics')"
                >
                    <icon
                        name="stats"
                        v-tooltip="showTooltip('route.statistics.name')"
                    />{{ $t("route.statistics.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    viewport !== 'd' ||
                    !$onduro.hasRole(['owner', 'planner', 'manager'])
                "
            >
                <router-link class="router-link" :to="$onduro.route('profile')">
                    <icon
                        name="profile"
                        v-tooltip="showTooltip('route.profile.name')"
                    />{{ $t("route.profile.name") }}
                </router-link>
            </li>

            <li v-if="$onduro.hasModule('documents')">
                <router-link
                    class="router-link"
                    :to="$onduro.route('documents')"
                >
                    <icon
                        name="insert-drive-file"
                        v-tooltip="showTooltip('route.documents.name')"
                    />{{ $t("route.documents.name") }}
                </router-link>
            </li>

            <li v-if="$onduro.hasRight('user.edit')">
                <router-link class="router-link" :to="$onduro.route('team')">
                    <icon
                        name="team"
                        v-tooltip="showTooltip('route.team.name')"
                    />{{ $t("route.team.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.hasModule('resources') &&
                    ($onduro.hasRight('user.edit') ||
                        $onduro.hasRole('planner'))
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('resources')"
                >
                    <icon
                        name="car"
                        v-tooltip="showTooltip('route.resources.name')"
                    />{{ $t("route.resources.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $current.account.sko && $onduro.hasRole('owner', 'manager')
                "
            >
                <router-link class="router-link" :to="$onduro.route('log')">
                    <icon
                        name="log"
                        v-tooltip="showTooltip('route.log.name')"
                    />{{ $t("route.log.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.hasModule('absence') &&
                    $onduro.hasRole(['owner', 'manager', 'planner'])
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('absences')"
                >
                    <icon
                        name="ambulance"
                        v-tooltip="showTooltip('route.absences.name')"
                    />{{ $t("route.absences.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.hasRole('owner', 'manager') &&
                    !$current.membership.restrictions.manager.limited
                "
            >
                <router-link
                    class="router-link"
                    :to="$onduro.route('settings')"
                >
                    <icon
                        name="cog"
                        v-tooltip="showTooltip('route.settings.name')"
                    />{{ $t("route.settings.name") }}
                </router-link>
            </li>

            <li
                v-if="
                    $onduro.isReal() &&
                    $onduro.hasRole('owner', 'manager') &&
                    !$current.account.sko
                "
            >
                <router-link class="router-link" :to="$onduro.route('modules')">
                    <icon
                        name="modules"
                        v-tooltip="showTooltip('route.modules.name')"
                    />{{ $t("route.modules.name") }}
                </router-link>
            </li>

            <li v-if="!current.user.demo" class="help">
                <a
                    class="router-link box-intercom"
                    href="mailto:support@onduro.com"
                >
                    <icon name="help" v-tooltip="showTooltip('text.help')" />{{
                        $t("text.help")
                    }}
                </a>
            </li>

            <li v-if="$onduro.hasRole('owner')">
                <router-link
                    class="router-link"
                    :to="$onduro.route('subscription')"
                >
                    <icon
                        name="company"
                        v-tooltip="showTooltip('route.subscription.name')"
                    />{{ $t("route.subscription.name") }}
                </router-link>
            </li>

            <li v-if="current.user.super">
                <a
                    class="router-link"
                    href="#"
                    @click.prevent="$widget.open('switcher')"
                >
                    <icon name="switch" />Switch
                </a>
            </li>

            <li class="languages">
                <router-link
                    :to="$onduro.switchLanguage('de')"
                    @click.native="switchLanguage('de')"
                    :class="$store.state.meta.lang == 'de' ? 'is-active' : ''"
                    >DE</router-link
                >
                |
                <router-link
                    :to="$onduro.switchLanguage('nl')"
                    @click.native="switchLanguage('nl')"
                    :class="$store.state.meta.lang == 'nl' ? 'is-active' : ''"
                    >NL</router-link
                >
                |
                <router-link
                    :to="$onduro.switchLanguage('en')"
                    @click.native="switchLanguage('en')"
                    :class="$store.state.meta.lang == 'en' ? 'is-active' : ''"
                    >EN</router-link
                >
                <template v-if="$current.profile == 'Pier14'">
                    |
                    <router-link
                        :to="$onduro.switchLanguage('pl')"
                        @click.native="switchLanguage('pl')"
                        :class="
                            $store.state.meta.lang == 'pl' ? 'is-active' : ''
                        "
                        >PL</router-link
                    >
                </template>
            </li>

            <li>
                <span class="version" @click.prevent="refresh"
                    >V #{{ version }}</span
                >
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "Navigation",

    data() {
        return {
            touching: false,
        };
    },

    computed: {
        version() {
            return process.env.VERSION;
        },

        ...mapState({
            authenticated: ({ auth }) => auth.authenticated,
            viewport: ({ layout }) => layout.viewport,
            hasNavigation: ({ layout }) => layout.hasNavigation,
            appReady: ({ app }) => app.ready,
            availability: ({ current }) => current.membership.availability,
            balance: ({ current }) => current.membership.balance,
            current: ({ current }) => current,
        }),

        showAvailability() {
            return (
                this.$onduro.hasModule("availability") &&
                (this.$onduro.hasRole("planner") || this.availability)
            );
        },
    },

    methods: {
        showTooltip(key) {
            if (!this.hasNavigation) return this.$t(key);

            return null;
        },

        showNavigation() {
            // method must be triggered by mouse event only
            if (this.touching) return;

            this.$store.dispatch("layout/showNavigation");
        },

        hideNavigation() {
            // method must be triggered by mouse event only
            if (this.touching) return;

            this.$store.dispatch("layout/hideNavigation");
        },

        toggleNavigation() {
            this.$store.dispatch("layout/toggleNavigation");
            this.touching = false;
        },

        switchLanguage(lang) {
            // store lang on user profile
            this.$http.put("/api/switch/locale/" + lang);

            // // update moment.js locale
            // if (lang != 'en')
            // {
            //     require('moment/locale/' + lang);
            //     moment().locale(lang);
            //     console.info('mom', lang);
            // }
        },

        refresh() {
            // force hard reload
            window.location.reload(true);
        },
    },
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?836ce092